import { Link } from "@inertiajs/react"

const CustomLink = (props: any) => {
  const { href, node, ...rest } = props

  if (!href) {
    return <a {...rest} />
  }

  if (href.startsWith("/")) {
    return <Link href={href} {...rest} />
  }

  if (href.startsWith("#")) {
    return <a href={href} {...rest} />
  }

  return <a href={href} target="_blank" rel="noopener noreferrer" {...rest} />
}

export default CustomLink
